import { scrollToId } from "@/lib/content";

export const Footer = () => (
  <footer className="border-t border-stone-900/10 bg-ivory py-12" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:flex-row sm:items-center sm:px-8">
      <div>
        <button
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="font-serif text-xl tracking-[0.22em] text-ink"
          data-testid="footer-wordmark"
        >
          BALIBIG<span className="text-gold">VILLAS</span>
        </button>
        <p className="mt-3 max-w-sm text-xs font-light leading-relaxed text-stone-500">
          All villa imagery and titles link directly to official Airbnb listings
          for verified transparency.
        </p>
      </div>
      <nav className="flex flex-wrap gap-x-8 gap-y-3">
        {["villas", "story", "experiences", "reviews"].map((id) => (
          <button
            key={id}
            data-testid={`footer-link-${id}`}
            onClick={() => scrollToId(id)}
            className="link-lux text-[11px] font-medium uppercase tracking-[0.2em] text-stone-600 hover:text-ink"
          >
            {id.replace("-", " ")}
          </button>
        ))}
      </nav>
    </div>
    <div className="mx-auto mt-10 max-w-7xl border-t border-stone-900/10 px-5 pt-6 sm:px-8">
      <p className="text-[11px] tracking-wide text-stone-400">
        © 2026 BALIBIGVILLAS. All Rights Reserved. Luxury Villa Portfolio in Bali, Indonesia.
      </p>
    </div>
  </footer>
);
